import React, { useState, useRef, useEffect, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { confirmDialog } from 'primereact/confirmdialog';


// ------------------ COMPONENTES DE BASE--------------------------
import Card from "../../../../Base/Components/Card/Card";
import { useForm } from "../../../../Base/Hooks/useForm";
import Loader from "../../../../Base/Components/Loader/Loader";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { getAreasAct } from "../../../../Base/API/Global/Areas/AreasRequests";
import { toastShow } from "../../../../Base/Services/ToastService";
import { setDateTimeSQLH } from "../../../../Base/Services/FechasService";

// ------------------- CONSULTAS A LA API---------------------------
import { GuardarPartida, obtenerNoPartida, getEncabezadoPorId, getDetallesPorId, EditarPartida, postEstadoDetalles } from "../../../../API/Finanzas/RegistroContable/LibroDiarioRequest";
import { getTasaCambio } from "../../../../API/CalendarioOperativo/CalendarioOperativoRequest";
import { getCuentasHijosQuick } from "../../../../API/Finanzas/RegistroContable/RegistroContableRequest";
import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";

const LibroDiarioCRUD = ({
    showDialog,
    setShowDialog,
    selectedEnc,
    setSelectedEnc,
    getInfo,
}) => {
    const toast = useRef(null);
    const { userAuth } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [listadoDetalles, setListadoDetalles] = useState([]);
    const [selected, setSelected] = useState([]);
    const [areas, setAreas] = useState([]);
    const [cuentas, setCuentas] = useState([]);
    const [estados, setEstados] = useState([]);
    const [habilitado, setHabilitado] = useState(true);
    const [hiddenEditar, setHiddenEditar] = useState(userAuth?.AccessWeb.split(",").map((e) => parseInt(e)).includes(64));

    const initialValues = {
        IdPartida: -190,
        Partida: "",
        IdEstado: 98,
        Memo: "",
        Fecha: new Date(),
        Comentarios: "",
        TasaCambio: 0,
        Monto: 0,
        IdCalendario: 0,
        IdReferencia: 1,
        IdTipo: 0,
        NumeroRegistro: "",
        NumeroPartida: "",
    }

    const { values, handleInputChange, setValues, resetForm } = useForm(initialValues);

    const getValoresIniciales = async () => {
        setLoading(true)
        const tasaCambioTempo = await getTasaCambio()
        const tempoCuentas = await getCuentasHijosQuick()
        let cuenta = []
        tempoCuentas.forEach(c => {
            cuenta.push({
                IdCuenta: c.IdAccount,
                Cuenta: c.CuentaQuick,
                Account: c.Account
            })
        });
        setCuentas(cuenta)
        const areasTempo = await getAreasAct()
        setAreas(areasTempo)

        const estadosTempo = await getEstadosCategory('LibroDiario')
        setEstados(estadosTempo)

        if (selectedEnc?.length > 0) {
            let IdPartida = selectedEnc[0]?.IdPartida
            const encabezadoTempo = await getEncabezadoPorId(IdPartida)
            // setHabilitado(true)

            // if (encabezadoTempo[0]?.Fecha) {
            //     let mesActual = new Date().getMonth() + 1
            //     let anioActual = new Date().getFullYear()

            //     let fechaPartida = new Date(encabezadoTempo[0]?.Fecha)
            //     let mesPartida = fechaPartida.getMonth() + 1
            //     let anioPartida = fechaPartida.getFullYear()

            //     // if (mesActual === mesPartida && anioActual === anioPartida) {
            //     //     setHabilitado(false)
            //     // } else {
            //     //     setHabilitado(true)
            //     // }
            // }

            setValues({
                ...encabezadoTempo[0],
                IdPartida: IdPartida,
                IdEstado: 98,
                StatusName: "Creado",
                TasaCambio: encabezadoTempo[0]?.TasaCambio,
                Fecha: new Date(encabezadoTempo[0]?.Fecha),
                Memo: encabezadoTempo[0]?.Memo,
            })
            const detallesTempo = await getDetallesPorId(IdPartida)
            setListadoDetalles(detallesTempo)
        } else {
            setHabilitado(false)
            const numeroTempo = await obtenerNoPartida()

            setValues({
                ...initialValues,
                IdEstado: 98,
                StatusName: "Creado",
                NumeroPartida: numeroTempo[0]?.FormatoPartida,
                TasaCambio: tasaCambioTempo[0]?.TasaCambio
            })
        }
        setLoading(false)
    };

    const agregarNuevaFila = () => {
        let newRow = [...listadoDetalles]
        let dataNueva = [{
            IdMovimiento: Math.floor(-(listadoDetalles.length + 1) * Math.random() * 1000),
            IdPartida: values?.IdPartida,
            IdEstado: 98,
            Fecha: setDateTimeSQLH(new Date()),
            IdCuenta: 0,
            Cuenta: '',
            Memo: '',
            IdCuentaDebito: 0,
            CuentaDebito: '',
            DebitoL: 0,
            DebitoD: 0,
            IdCuentaCredito: 0,
            CuentaCredito: '',
            CreditoL: 0,
            CreditoD: 0,
            IdTipoMovimiento: 1,
            TipoMovimiento: '',
            IdReferencia: 0,
            Referencia: '',
            Comentarios: '',
            IdUserEdit: userAuth?.IdUser,
            IdUserCreate: userAuth?.IdUser,
        }]
        if (selected.length === 0) {
            newRow = newRow.concat(dataNueva)
        } else {
            const ultimoSelect = selected[selected.length - 1];
            const index = newRow.findIndex(detail => detail.IdMovimiento === ultimoSelect.IdMovimiento)
            newRow.splice(index + 1, 0, dataNueva[0])
        }
        setListadoDetalles(newRow)
        setSelected([])
    }

    const nuevaFilaDiaria = (tipo, data, nuevoValor = 0) => {

        let detalle = data
        let tempo = [...listadoDetalles]

        let montoDebitoL = 0, montoCreditoL = 0
        let montoDebitoD = 0, montoCreditoD = 0

        const index = tempo.findIndex(detail => detail.IdMovimiento === detalle.IdMovimiento)
        tempo[index] = detalle

        let cantidadDebito = tempo.reduce((total, value) => total + (value.DebitoL ? value.DebitoL : 0), 0)
        let cantidadCredito = tempo.reduce((total, value) => total + (value.CreditoL ? value.CreditoL : 0), 0)

        if (cantidadDebito !== cantidadCredito) {
            if (cantidadCredito < cantidadDebito) {
                montoCreditoL = cantidadDebito - cantidadCredito
                montoCreditoD = (cantidadDebito - cantidadCredito) / values.TasaCambio
            } else {
                montoDebitoL = cantidadCredito - cantidadDebito
                montoDebitoD = (cantidadCredito - cantidadDebito) / values.TasaCambio
            }
            let dataNueva = [{
                IdMovimiento: -1 * listadoDetalles.length,
                IdPartida: values.IdPartida,
                IdEstado: 98,
                Fecha: setDateTimeSQLH(new Date()),
                IdCuenta: 0,
                Cuenta: '',
                Memo: '',
                IdCuentaDebito: 0,
                CuentaDebito: '',
                DebitoL: montoDebitoL,
                DebitoD: montoDebitoD,
                IdCuentaCredito: 0,
                CuentaCredito: '',
                CreditoL: montoCreditoL,
                CreditoD: montoCreditoD,
                IdTipoMovimiento: 1,
                TipoMovimiento: '',
                IdReferencia: 0,
                Referencia: '',
                Comentarios: '',
                IdUserEdit: userAuth?.IdUser,
                IdUserCreate: userAuth?.IdUser,
            }]
            // newRow.push(dataNueva)
            setListadoDetalles([...listadoDetalles, ...dataNueva])
        }


    }

    const verificarCampos = () => {
        let err = false;

        if (!values?.TasaCambio) {
            err = true;
            toastShow(toast, "error", "Error", "Tasa de Cambio es requerida.");
            return;
        }
        if (!values?.Fecha) {
            err = true;
            toastShow(toast, "error", "Error", "La fecha es requerida.");
            return;
        }
        if (!values?.Memo) {
            err = true;
            toastShow(toast, "error", "Error", "Memo es requerido.");
            return;
        }

        return !err;
    };

    const guardarInformacion = async () => {
        if(verificarCampos()){
            let cuentasExistentes = listadoDetalles.some((l) => l.IdCuenta === 0 || l.IdCuenta === null)
            if(listadoDetalles.length > 0 && !cuentasExistentes){
                let cantidadMontoCredito = listadoDetalles.reduce((total, l) => total + (!l.CreditoL ? 0 : l.CreditoL), 0)
                let cantidadMontoDebito = listadoDetalles.reduce((total, l) => total + (!l.DebitoL ? 0 : l.DebitoL), 0)
                if (cantidadMontoCredito === cantidadMontoDebito) {
    
                    let message = <div>¿Está seguro que desea guardar la información?</div>
                    confirmDialog({
                        message: message,
                        header: 'Confirmación',
                        icon: 'pi pi-exclamation-triangle',
                        accept: async () => {
                            setLoading(true)
                            
                            let encabezado = {
                                ...values,
                                IdPartida: values?.IdPartida,
                                Fecha: setDateTimeSQLH(values.Fecha),
                                IdTipoReferencia: values?.IdTipoReferencia ? values?.IdTipoReferencia : 1,
                                IdEstado: values?.StatusName?.IdStatus || values?.IdEstado
                            }
                            let detalles = listadoDetalles.map(l => {
                                return {
                                    ...l,
                                    IdPartida: values?.IdPartida,
                                    CreditoD: l.CreditoL / values?.TasaCambio,
                                    DebitoD: l.DebitoL / values?.TasaCambio,
                                    IdUser: userAuth?.IdUser
                                }
                            })
    
                            // console.log(encabezado);
                            // setLoading(false)
                            if(encabezado?.IdPartida > 0){
                                const resp = await EditarPartida(encabezado, detalles)
                                if(resp[0]?.ESTADO === 1){
                                    toastShow(toast, 'success', 'Guardada', resp[0]?.MENSAJE)
                                    setLoading(false)
                                    setTimeout(() => {
                                        setShowDialog(false)
                                        getInfo()
                                    }, 500);
                                }else{
                                    toastShow(toast, 'error', 'Error', resp[0]?.MENSAJE)
                                    setLoading(false)
                                }
                            }else{   
                                const resp = await GuardarPartida(encabezado, detalles)
                                if(resp[0]?.ESTADO === 1){
                                    toastShow(toast, 'success', 'Guardada', resp[0]?.MENSAJE)
                                    setLoading(false)
                                    setTimeout(() => {
                                        setShowDialog(false)
                                        getInfo()
                                    }, 500);
                                }else{
                                    toastShow(toast, 'error', 'Error', resp[0]?.MENSAJE)
                                    setLoading(false)
                                }
                            }
                        },
                        reject: () => { }
    
                    })
    
                } else {
                    toastShow(toast, 'error', 'Existe una diferencia entre los valores ingresados')
                }
            } else {
                toastShow(toast, 'warn', 'Agregue información', 'Debe la información necesaria en los detalles')
            }
        }
    }

    const habilitarComponentes = () => {
        if (values?.Fecha) {
            let mesActual = new Date().getMonth() + 1
            let anioActual = new Date().getFullYear()

            let fechaPartida = new Date(values?.Fecha)
            let mesPartida = fechaPartida.getMonth() + 1
            let anioPartida = fechaPartida.getFullYear()
            if (mesActual === mesPartida && anioActual === anioPartida) {
                setHabilitado(false)
            } else {
                toastShow(toast, 'warn','Advertencia','La partida que desea editar no es del mes actual, tenga en cuenta que modificara datos de otros meses.')
                setHabilitado(false)
            }
        }
        
    }
    
    const removerFila = async () => {
        let listadoRemover = selected.filter(e => e.IdMovimiento > 0)
        let listadoEnviar = listadoRemover.map((e) => {
            return {
                IdMovimiento: e.IdMovimiento,
                IdUser: userAuth?.IdUser,
                IdEstado: 101,
            }
        })
        let listadoFinal = listadoDetalles.filter(i => !selected.some(e => e.IdMovimiento === i.IdMovimiento))
        const result = await postEstadoDetalles(listadoEnviar)
        if (!result) {
            toastShow(toast, 'error', 'Ocurrio un error al remover la fila ')
        }
        setListadoDetalles(listadoFinal)
    }

    const columnsDet = [
        {
            field: "IdMovimiento",
            header: "ID",
            frozen: 1,
            headerEn: "ID",
            className: "Xsmall",
            hidden: userAuth.IdRol === 1,
        },
        {
            field: 'Cuenta',
            header: 'Cuenta',
            filter: true,
            editable: !habilitado,
            Format: 'AutoComplete',
            value: 'IdCuenta',
            label: 'Cuenta',
            items: cuentas,
            Sumary: 'count',
            minWidth: 600,
        },
        {
            field: "DebitoL",
            header: "DebitoL",
            headerEn: "DebitoL",
            className: "small",
            Format: "Currency",
            Sumary: "sum",
            editable: !habilitado,
            onChange: (data) => {
                nuevaFilaDiaria(1, data.data, data.newValue)
            }
        },
        {
            field: "CreditoL",
            header: "CreditoL",
            headerEn: "CreditoL",
            className: "small",
            Format: "Currency",
            Sumary: "sum",
            editable: !habilitado,
            onChange: (data) => {
                nuevaFilaDiaria(2, data.data, data.newValue)
            },
        },
        {
            field: "Memo",
            header: "Memo",
            headerEn: "Memo",
            className: "",
            flex: 1,
            editable: !habilitado,
            minWidth: 300,
        },
        {
            field: 'Area',
            header: 'Centro Costos',
            className: 'large',
            filter: true,
            editable: !habilitado,
            Format: 'AutoComplete',
            value: 'IdArea',
            label: 'Area',
            items: areas,
        },
    ];

    const table = {
        Columns: columnsDet,
        Data: listadoDetalles,
        selected: selected,
        setSelected: setSelected,
    };

    useEffect(() => {
        if (showDialog) {
            getValoresIniciales()
        }
    }, [showDialog]);

    return (
        <div>
            <Dialog
                visible={showDialog}
                style={{ width: "95vw", height: "90vh" }}
                onHide={() => {
                    setShowDialog(false)
                    setSelectedEnc([])
                }}
                header={values?.NumeroPartida}
                maximizable
            >
                <Toast ref={toast} />
                <Loader loading={loading} querySelector={"#DetallesLibro"} />
                <div className="contenedorLD">
                    <Card
                        contenido={
                            <div className="d-flex flex-row gap-2">
                                <AutoCompleteDropdown
                                    enable={!habilitado && values?.IdPartida > 0}
                                    value={values?.StatusName}
                                    items={estados}
                                    field={"StatusName"}
                                    name={"StatusName"}
                                    handleInputChange={handleInputChange}
                                    label={"Estado"}
                                />

                                <span className=" field p-float-label">
                                    <InputNumber
                                        disabled={habilitado}
                                        minFractionDigits={2}
                                        maxFractionDigits={2}
                                        useGrouping={true}
                                        id="TasaCambio"
                                        name="TasaCambio"
                                        style={{ height: 47 }}
                                        value={values?.TasaCambio}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="TasaCambio">Tasa de Cambio</label>
                                </span>

                                <span className="p-float-label">
                                    <Calendar
                                        id="Fecha"
                                        name="Fecha"
                                        disabled={habilitado}
                                        onChange={(e) => handleInputChange(e, "Fecha")}
                                        value={values?.Fecha}
                                        style={{ height: 47 }}
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999"
                                        showIcon
                                    />
                                    <label htmlFor="Fecha">Fecha</label>
                                </span>

                                <span className=" p-float-label d-flex">
                                    <InputText
                                        id="Memo"
                                        name="Memo"
                                        disabled={habilitado}
                                        value={values?.Memo}
                                        style={{ width: 900 }}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="Memo">Memo</label>
                                </span>

                                <Button
                                    icon="pi pi-plus"
                                    onClick={() => agregarNuevaFila()}
                                    disabled={habilitado}
                                />

                                {(values?.IdTipoReferencia === 1 && hiddenEditar) && (
                                    <Button
                                        icon="pi pi-pencil"
                                        onClick={() => habilitarComponentes()}
                                    />
                                )}
                                

                                <Button
                                    icon="pi pi-save"
                                    style={{}}
                                    onClick={() => guardarInformacion()}
                                    disabled={habilitado}
                                />
                                
                                {(values?.IdTipoReferencia === 1 && hiddenEditar) && (
                                    <Button
                                        icon="pi pi-times"
                                        severity="danger"
                                        onClick={() => removerFila()}
                                        disabled={habilitado || selected?.length <= 0}
                                    />
                                )}
                                
                                <Button icon="pi pi-refresh" onClick={() => getValoresIniciales()} />
                            </div>
                        }
                    />
                </div>

                <div style={{ height: "73vh" }} className="pt-4" id="DetallesLibro">
                    <AgGrid table={table} />
                </div>
            </Dialog>
        </div>
    );
};

export default LibroDiarioCRUD;
